import React, { useContext } from "react";
import { CepContext } from "./cep-context";
import { CityCeps } from "./cep-models";
import { useCopy } from "../components/copy-hook";

function CityItem({city}:{city:CityCeps}){

    const copy = useCopy()

    function doCopy(){
        copy(city.ceps.join('\n'))
    }


    return <>
        <h4>{city.name} <i className="copy-button ms-2 far fa-copy" onClick={doCopy}></i></h4>
        <div className="cep-list">
        {city.ceps.map(c => <span key={c} className="badge me-2 mb-2">{c}</span>)}
        </div>
    </>
}

export function SearchResult(){
    const {state:{cities, searchTerm}} = useContext(CepContext)

    if(!cities) return null

    return <div className="">
        {cities.map(c => <CityItem city={c} />)}
    </div>

}